import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class SubscriptionService {

	constructor() {
	}

	unSubscribe(subscriptions) {
		for (const sub of subscriptions) {
			if (sub && Array.isArray(sub)) {
				for (const s of sub) {
					if (s) {
						s.unsubscribe();
					}
				}
			} else if (sub) {
				sub.unsubscribe();
			}
		}
	}
}
